module.exports = __webpack_public_path__ + "static/Corprate_Careers-IN_11-71b8b6c842a3c3afcf674eebcdcafe0c.jpg";